import {ReactNode} from 'react';
import {AnalyticsProvider as BaseAnalyticsProvider} from '@stripe-internal/nautilus-components';
import {ClientFactory} from 'mkt-ssr/lib/analytics/createAnalyticsClient';
import {useIsServer, useStripeEnv} from 'mkt-ssr/lib/env';
import {useGeoIPCountry, useGlobalizationPair} from 'mkt-ssr/lib/globalization';

export {
  useAnalytics,
  useGetPreviousEventId,
  useInternalAnalyticsClient,
  formatAnalyticsLabel,
} from '@stripe-internal/nautilus-components';

export function AnalyticsClientProvider({children}: {children: ReactNode}) {
  const env = useStripeEnv();
  const isSSR = useIsServer();
  const globalizationPair = useGlobalizationPair();
  const geoIPCountry = useGeoIPCountry();

  return (
    <BaseAnalyticsProvider
      createClient={ClientFactory.createAnalyticsClient}
      env={env}
      isSSR={isSSR}
      globalizationPair={globalizationPair}
      geoIPCountry={geoIPCountry}
    >
      {children}
    </BaseAnalyticsProvider>
  );
}
